import { render, staticRenderFns } from "./CountsWidget.vue?vue&type=template&id=7aca7cf8&scoped=true&"
import script from "./CountsWidget.vue?vue&type=script&lang=js&"
export * from "./CountsWidget.vue?vue&type=script&lang=js&"
import style0 from "./CountsWidget.vue?vue&type=style&index=0&id=7aca7cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca7cf8",
  null
  
)

export default component.exports